// src/utils/toastUtils.ts
import { toast } from 'react-toastify';

export const showToastSuccess = (message: string) => {
    toast.success(message, { position: 'top-right', autoClose: 3000 });
};

export const showToastError = (message: string) => {
    toast.error(message, { position: 'top-right', autoClose: 4000 });
};

export const showToastInfo = (message: string) => {
    toast.info(message, { position: 'top-right', autoClose: 3000 });
};

export const showToastWarning = (message: string) => {
    toast.warning(message, { position: 'top-right', autoClose: 3000 });
};
